import React from 'react';
import styled from 'styled-components';


const SubmitBtnBlock = styled.button`
    height:${props => props.height || '55px'};
    margin-top: ${props => props.marginTop || '5px'};
    font-size: ${props => props.fontSize || '22px'};
    font-weight: ${props => props.fontWeight || '500'};
    border-radius: ${props => props.borderRadius || '4px'};
    width: ${props => props.width || '379px'};
    float: right;
    position: relative;
    color: ${props => props.textColor || '#bbb'};
    background-color: ${props => props.bgColor || '#e0e0e0'};
    border: 1px solid ${props => props.bgColor || '#e0e0e0'};

    ${props=>props.arrowDirction!=="none"&&`
    &::before {
        content: '';
        display: block;
        position: absolute;
        ${props.arrowDirction}: -2px;
        left: 50%;
        width: 0;
        height: 0;
        border-${props.arrowDirction}: 10px solid ${props.arrowColor || '#ececec'};
        /*border-bottom: none;*/
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        transform: translateX(-50%)
    }
    
    `};
    };
`;

const SubmitBottomBtnBlock = styled.button`
    height:${props => props.height || '55px'};
    margin-top: ${props => props.marginTop || '5px'};
    font-size: ${props => props.fontSize || '22px'};
    font-weight: ${props => props.fontWeight || '500'};
    border-radius: ${props => props.borderRadius || '4px'};
    width: ${props => props.width || '379px'};
    float: right;
    position: relative;
    color: ${props => props.textColor || '#bbb'};
    background-color: ${props => props.bgColor || '#e0e0e0'};
    border: 1px solid ${props => props.bgColor || '#e0e0e0'};

    &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: -2px;
        left: 50%;
        width: 0;
        height: 0;
        border-top: none;
        border-bottom: 10px solid ${props => props.arrowColor || '#ececec'};
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        transform: translateX(-50%)
    }
`;


/**
 * 수납함에 담기, 견적요청하기에 사용하는 버튼
 */
const SubmitBtn = ({ width, height, marginTop,
    fontSize, fontWeight, borderRadius,
    bgColor, arrowColor, text, textColor, onClick, arrowDirction = 'top' }) => {
    return (
      <SubmitBtnBlock width={width}
                      height={height}
                      marginTop={marginTop}
                      fontSize={fontSize}
                      bgColor={bgColor}
                      fontWeight={fontWeight}
                      borderRadius={borderRadius}
                      arrowDirction={arrowDirction}
                      arrowColor={arrowColor}
                      textColor={textColor}
                      onClick={onClick}
      >
          {text}
      </SubmitBtnBlock>
    );

};

export default SubmitBtn;
